module.exports = __webpack_public_path__ + "img/casa 2.afb42bf6.jpg";